import React from 'react';
import { Typography, Box, Divider } from '@mui/material';

const Disclaimer = ({ disclaimerText, clickableText, onPress, style, dividerStyle }) => {
  const parts = disclaimerText.split(clickableText);

  return (
    <Box>
      <Divider style={{ marginTop: 10, ...dividerStyle }} />
      <Box sx={{display: 'flex', justifyContent: 'left', mt: 1}}>
        <Typography style={{ fontSize: 12, color: '#ffffff', textAlign: 'left', ...style }}>
          {parts[0]}
          <span
            onClick={onPress}
            style={{
              fontWeight: 'bold',
              cursor: 'pointer',
              fontSize: 12,
              color: '#ffffff',
              ...style
            }}
          >
            {clickableText}
          </span>
          {parts[1]}
        </Typography>
      </Box>
    </Box>
  );
};

export default Disclaimer;
